module.exports = __webpack_public_path__ + "static/media/fvs_valve1_111.f34833ea.jpg";